import { MoreVert } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Collapse, IconButton, TableCell, TableRow } from "@mui/material";
import { Fragment, useState } from "react";

import HNSColors from "../../../ui library/HNSColors";
import { usePaymentsRowMenuHandlers } from "../hooks/usePaymentsEventHandlers";

import PaymentsDropdownMenu from "./PaymentsDropdownMenu";
import PaymentsRowDetails from "./PaymentsRowDetails";

export default function PaymentsListItem({
  data,
  onDelete,
  onEdit,
  canEdit = false,
  canDelete = false,
}) {
  const [open, setOpen] = useState(false);
  const showActions = canEdit || canDelete;
  const { anchorEl, menuOpen, handleDelete, handleEdit, handleMenuClose, handleMenuOpen } =
    usePaymentsRowMenuHandlers({ data, onDelete, onEdit });

  return (
    <Fragment>
      <TableRow hover sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">
          <IconButton size="small" onClick={() => setOpen((prev) => !prev)}>
            {open ? (
              <KeyboardArrowUpIcon sx={{ color: HNSColors.primary[500] }} />
            ) : (
              <KeyboardArrowDownIcon sx={{ color: HNSColors.primary[500] }} />
            )}
          </IconButton>
        </TableCell>
        <TableCell>{data.validFrom}</TableCell>
        <TableCell>{data.validTo}</TableCell>
        <TableCell>{data.paymentMethod}</TableCell>
        <TableCell>{data.bankName}</TableCell>
        {showActions && (
          <TableCell align="right">
            <div className="flex items-center justify-end">
              <IconButton size="small" onClick={handleMenuOpen}>
                <MoreVert sx={{ color: HNSColors.primary[500], fontSize: 24 }} />
              </IconButton>
            </div>
            <PaymentsDropdownMenu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleMenuClose}
              onEdit={handleEdit}
              onDelete={handleDelete}
              paymentId={data.id}
              canEdit={canEdit}
              canDelete={canDelete}
            />
          </TableCell>
        )}
      </TableRow>
      <TableRow>
        <TableCell className="pb-0 pt-0" colSpan={showActions ? 6 : 5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box className="px-2 py-3">
              <PaymentsRowDetails data={data} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
